import React from "react";
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";

import { signOut } from "../../store/modules/auth/actions";
import * as S from "./styled";

const Profile = ({ open, username, usercpf, avatar }) => {
  const dispatch = useDispatch();

  function handleSignOut() {
    dispatch(signOut());
  }

  return (
    <S.Container>
      <S.MenuContent>
        <S.UserData>
          <S.UserName>{username}</S.UserName>
          <S.UserCpf>{usercpf}</S.UserCpf>
        </S.UserData>
        <S.MenuWrapper>
          <S.UserAvatar src={avatar} alt={username} />
          <S.MenuBtn>
            ▼
            <S.DropdownContent className="dropdown">
              <ul>
                <li><Link to="/profile">Meu Perfil</Link></li>
                <li><button type="submit" onClick={handleSignOut}>Sair</button></li>
              </ul>
            </S.DropdownContent>
          </S.MenuBtn>
        </S.MenuWrapper>
        </S.MenuContent>
      <S.MenuMobile open={open}>
        <li><Link to="/profile">Meu Perfil</Link></li>
        <li><button type="submit" onClick={handleSignOut}>Sair</button></li>
      </S.MenuMobile>
    </S.Container>
  );
};

export default Profile;
